module.exports = __webpack_public_path__ + "img/slide7.8091822b.jpg";